import { Component, Inject, OnInit } from '@angular/core'
import { ActionFailed, Destroyable, SaveForm, Toaster, untilDestroy } from '@tokeet-frontend/tv3-platform'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Store } from '@ngrx/store'
import * as lodash from 'lodash'
import { BdcClosePropertyReason } from 'libs/channel-content/src/lib/store/bdc/model-v2/modernised-api/bdc-status-close'
import { BdcCheckPropertyStatusOperation, BdcContentV2Service } from '@tokeet-frontend/channel-content'

@Component({
  selector: 'app-bdc-close-property-dialog',
  templateUrl: './bdc-close-property-dialog.component.html',
  host: { class: 'modal-content' },
  styleUrls: ['./bdc-close-property-dialog.component.scss'],
})
export class BdcClosePropertyDialogComponent extends Destroyable implements OnInit {
  form = this.fb.group({
    type: ['', [Validators.required]],
    description: [''],
  })

  types = Object.values(BdcClosePropertyReason)
  bindLabel = (t: string) => lodash.startCase(lodash.lowerCase(t))

  constructor(
    public dialogRef: MatDialogRef<BdcClosePropertyDialogComponent>,
    private fb: FormBuilder,
    private store: Store<any>,
    private toaster: Toaster,
    private service: BdcContentV2Service,
    @Inject(MAT_DIALOG_DATA) private data: { propertyId: number }
  ) {
    super()
  }

  ngOnInit(): void {
    this.form
      .get('type')
      .valueChanges.pipe(untilDestroy(this))
      .subscribe((v) => {
        const ctrl = this.form.get('description')
        if (v === BdcClosePropertyReason.Other) {
          ctrl.setValidators([Validators.required])
        } else {
          ctrl.clearValidators()
        }
        ctrl.updateValueAndValidity()
      })
  }

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  onSave(form: FormGroup) {
    const formValues = form.getRawValue()
    this.service
      .checkPropertyStatus(this.data.propertyId, {
        operation: BdcCheckPropertyStatusOperation.CLOSE,
        reason: formValues,
      })
      .subscribe(
        () => {
          this.toaster.success($localize`Property closed successfully.`)
          this.dialogRef.close('success')
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }
}
